import { render, staticRenderFns } from "./WeniChat.vue?vue&type=template&id=86fdcc5a"
import script from "./WeniChat.vue?vue&type=script&lang=js"
export * from "./WeniChat.vue?vue&type=script&lang=js"
import style0 from "./WeniChat.vue?vue&type=style&index=0&id=86fdcc5a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports